import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type StarfishChildDeviceRegistrationEndpointSpecification = ApiEndpointSpecification;
export const StarfishChildDeviceRegistrationEndpointSpecification: StarfishChildDeviceRegistrationEndpointSpecification = {
    url: '/api/device/registration/childdevice',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'StarfishChildDeviceRegistrationRequestParams',
    requestBodySchemaName: 'StarfishChildDeviceRegistrationRequestBody',
    okResponseSchemaName: 'StarfishChildDeviceRegistrationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 3,
};  

export const invokeStarfishChildDeviceRegistration = Helpers.makeApiRequestFn<
    Types.StarfishChildDeviceRegistrationRequestParams,
    Types.StarfishChildDeviceRegistrationRequestBody,
    Types.StarChildDeviceRegistrationOkResponse
>(StarfishChildDeviceRegistrationEndpointSpecification);
